import Global from './../global';

export default {
  treeWalk(startElement) {
    // IE 11 requires the third and fourth arguments be present. If the ghird
    // arg is null, it applies the default behaviour. However IE also requires
    // the fourth argument be present even though the other browsers ignore it.
    let treeWalker = document.createTreeWalker(
      startElement,
      NodeFilter.SHOW_ELEMENT,
      null,
      false
    );

    let nodeList = [],
      node;
    while ((node = treeWalker.nextNode())) {
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        ['SCRIPT', 'LINK'].includes(node.nodeName.toUpperCase())
      ) {
        nodeList.push(treeWalker.currentNode);
      }
    }

    for (let i = 0; i < nodeList.length; i++) {
      nodeList[i].parentNode.removeChild(nodeList[i]);
    }

    const htmlElements = {
      scriptsList: nodeList,
      plainHTML: startElement
    };

    return htmlElements;
  },

  stringToHtml(theString) {
    let d = document,
      i,
      containerElement = d.createElement('div'),
      fragment = d.createDocumentFragment();

    containerElement.innerHTML = theString;

    // when using appendChild it actually moves the reference of containerElement's firstChild from containerElement to the fragment node
    // in this way the firstChild will always be the next element, until containerElement has no remaining elems and exits while condition
    while ((i = containerElement.firstChild)) {
      fragment.appendChild(i);
    }
    return fragment;
  },

  appendScriptsToNode(targetID, nodes) {
    nodes.map(node => {
      switch (node.tagName) {
        case 'SCRIPT': {
          const { src, innerHTML, onload, attributes } = node;
          const script = document.createElement('script');
          const targetElement = document.getElementById(targetID);

          if (onload) script.onload = onload;

          script.async = node.async || false;

          src && src.length > 0
            ? (script.src = src)
            : (script.innerHTML = innerHTML);

          const ignoredAttributes = ['async', 'src', 'innerHTML', 'onload'];
          [...(attributes || [])].forEach(x => {
            const isIgnored = ignoredAttributes.some(y => {
              y === x.name;
            });

            if (!isIgnored) script.setAttribute(x.name, x.value);
          });

          targetElement.appendChild(script);
          break;
        }
        case 'LINK': {
          const { rel, type, href, media } = node;
          const link = document.createElement('link');
          const targetElement = document.getElementById(targetID);
          link.rel = rel;
          link.type = type;
          link.href = href;
          link.media = media;
          targetElement.appendChild(link);
          break;
        }
        default:
          Global.logger.error('Appending scripts missed one ', node.tagName);
      }
    });
  },

  lookForPlaceholders(stringToProcess, placeholders) {
    for (let key in placeholders) {
      if (placeholders.hasOwnProperty(key)) {
        stringToProcess = stringToProcess.replace(
          new RegExp(key, 'g'),
          placeholders[key]
        );
      }
    }
    return stringToProcess;
  },

  createDivInBody(divId) {
    const divElem = document.createElement('div');
    divElem.setAttribute('id', divId);
    const [bodyElem] = document.getElementsByTagName('body');
    bodyElem.appendChild(divElem);
  },

  getHashRouteFromMetaTag() {
    const firstMetaTag = document.querySelector('meta[name=\'defaultHashTag\']');
    const routeWithHash = firstMetaTag
      ? firstMetaTag.getAttribute('content')
      : '';
    return routeWithHash.replace('#', '');
  }
};
